import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, hasAuthParams } from "react-oidc-context";
import { useState, useEffect } from "react";

const AuthControl = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const [hasTriedSignin, setHasTriedSignin] = useState(false);

  useEffect(() => {
    //Try to auto sign in
    if (
      !hasAuthParams() &&
      !auth.isAuthenticated &&
      !auth.activeNavigator &&
      !auth.isLoading &&
      !hasTriedSignin
    ) {
      auth.signinRedirect();
      setHasTriedSignin(true);
    } else {
      if (auth.isAuthenticated) {
        const beforeLoginUrl = sessionStorage.getItem("beforeLogin");
        sessionStorage.removeItem("beforeLogin");
        navigate(beforeLoginUrl ?? -1);
      }
    }
  }, [auth, hasTriedSignin, navigate]);

  //Render logic
  if (!auth.isAuthenticated) {
    switch (auth.activeNavigator) {
      case "signinSilent":
        return <div>Signing you in...</div>;
      case "signoutRedirect":
        return <div>Signing you out...</div>;
      //TODO: Default case
    }

    if (auth.isLoading) {
      return <div>Loading...</div>;
    }

    if (auth.error) {
      return <div>Oops... {auth.error.message}</div>;
    }
  }
};

export default AuthControl;
